import React, { useEffect } from 'react';

const ChromeToolsPortfolioPopup = ({
  isOpen,
  onClose,
  tools = [],
  title = 'Chrome Extension Portfolio',
  subtitle = 'These are some of the popular Chrome tools we have built for data extraction and business workflows.',
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleEsc = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleEsc);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="inquiry-popup-overlay" onClick={onClose}>
      <div
        className="inquiry-popup-dialog chrome-tools-popup"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="chrome-tools-popup-title"
      >
        <button
          type="button"
          className="inquiry-popup-close"
          onClick={onClose}
          aria-label="Close portfolio"
        >
          <span className="fa fa-times"></span>
        </button>

        <div className="inquiry-popup-head chrome-tools-popup-head">
          <span className="inquiry-popup-kicker">Built Tools</span>
          <h3 id="chrome-tools-popup-title">{title}</h3>
          <p>{subtitle}</p>
        </div>

        <div className="chrome-tools-popup-grid">
          {tools.map((tool) => (
            <a
              className="chrome-tools-popup-card"
              key={tool.name}
              href={tool.url}
              target="_blank"
              rel="noreferrer"
            >
              <div className="chrome-tools-popup-logo">
                <img
                  src={tool.logo}
                  alt={tool.name}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
              </div>
              <h4>{tool.name}</h4>
              <p>{tool.text}</p>
              <span className="chrome-tools-popup-link">
                {tool.url.includes('chromewebstore.google.com') || tool.url.includes('chrome.google.com')
                  ? 'Open Chrome Web Store'
                  : 'Open Tool Page'}
                <span className="fa fa-long-arrow-right"></span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChromeToolsPortfolioPopup;
